import axiosDefault from "axios";
import config from "../config";

const isProduction = process.env.NODE_ENV === "production";

// Exported the baseURL so we can reference it elsewhere, but we might want to think about moving this...

const defaultOptions = {
  baseURL: config.apiBaseUrl,
  withCredentials:true,
  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': config.axiosOrigin,
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
  },
};

const axios = axiosDefault.create(defaultOptions);
axios.defaults.withCredentials = true;

// These mutable values can change through sockets as well as HTTP saves.
// Keep the policy here so the flow editor, legacy editor and stream views agree.
const freshDataRoute = /(?:^|\/)(?:campaigns\/(?:campaign-overview|feature-vars|customisation-vars)|stream\/(?:feature-vars|customisation-vars))\/?$/;
let lastCacheBust = 0;

axios.interceptors.request.use(
  config => {
    const path = (config.url || '').split(/[?#]/)[0];
    if ((config.method || 'get').toLowerCase() === 'get' && freshDataRoute.test(path)) {
      // A new URL also bypasses responses cached before no-store was deployed.
      lastCacheBust = Math.max(Date.now(), lastCacheBust + 1);
      if (config.params instanceof URLSearchParams) {
        config.params = new URLSearchParams(config.params);
        config.params.set('_ts', String(lastCacheBust));
      } else {
        config.params = { ...config.params, _ts: lastCacheBust };
      }
      config.headers = {
        ...config.headers,
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache'
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor to log all responses for debugging
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error(`API Error: ${error.response?.status || 'Network Error'} ${error.config?.url || 'Unknown URL'}`, 
      error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axios;
